/*
 * VPDB - Virtual Pinball Database
 * Copyright (C) 2019 freezy <freezy@vpdb.io>
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 * Modified for sigmashake-pinball by SigmaShake, 2026.
 */

import type { ItemFrame } from "../../../shared/contracts";
import { ItemState } from "../../core/item-state";

export class LightState extends ItemState {
  /** Current brightness in the scale of the light intensity. */
  public intensity: number = 0;
  /** The full brightness (the intensity of the light data). */
  private readonly fullIntensity: number;

  public constructor(name: string, fullIntensity: number, isVisible: boolean) {
    super();
    this.name = name;
    this.fullIntensity = fullIntensity;
    this.isVisible = isVisible;
  }

  /** The frame brightness goes from 0 to 1. */
  public override toFrame(): ItemFrame {
    const level = this.fullIntensity > 0 ? Math.min(1, this.intensity / this.fullIntensity) : 0;
    return { name: this.name, kind: "light", intensity: level, visible: this.isVisible };
  }
}
